import type { FaireProductEntity } from "../../entity_types/product";

export const p_p3wzmp4eue: FaireProductEntity = {
  token: "p_p3wzmp4eue",
  type: "product",
  name: "Thank You Notecard No. 13 Set of 6 in Olive",
  brandToken: "b_umfa9a7xcn",
  brandName: "Jaymes Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/04b15339480bddc9bcab19a41c8b99d7e041b4892916524aaf7199e7976cc4a0.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/bfd4f1ca0ace555526d6b971b48aff8474fcade54bb03cfe5f290051b8329bae.jpeg",
    "https://cdn.faire.com/fastly/e10daab4736c900659cabf550aefe36176e5b123611def59384a38c8fa8b1f6e.jpeg",
    "https://cdn.faire.com/fastly/bd16e986454894d0169a933461135ffaa06eb01ae0972bede428d460a8e45975.jpeg",
    "https://cdn.faire.com/fastly/d843c7e2bdab74094cf20e3d69a9ef52784f629c7bb8aba97e04a71d60c965ae.jpeg",
  ],
  priceDollars: 18.5,
  description:
    'A set of 6 letterpressed Thank You notecards for your stationery collection. Comes in a set of 6 wrapped in a simple belly band & packaged in a premium plastic case for easy merchandising.\n\n * A2 Flat Blank Notecard Set \n * 4.25" x 5.5" \n * Set of 6 Notecards & Matching Envelopes \n * Letterpressed in Olive Ink \n * Available in Scarlet, Chartreuse, & Olive\n * Premium Double Thick Stock [570 GSM]\n',
  tags: [],
  msrpDollars: 37,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:54:48.846Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
